import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { getApiUrl } from '../../utils/api';
import { STATUS_OPTIONS } from './RenewalsPanel';

const API_URL = getApiUrl();

const fmt = (v) => (v ? new Date(v.length <= 10 ? `${v}T00:00:00` : v)
  .toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—');

/** Renewal Status — activates only once she has touched her 32nd week. The
 *  Future-Prospect follow-up date lives on the renewal row (Renewals tab), not
 *  here, so this modal stays light. */
export const RenewalStatusField = ({ leadId }) => {
  const [row, setRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/renewals/lead/${leadId}`, { withCredentials: true });
      setRow(data.row || null);
    } catch (e) {
      setRow(null);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { if (leadId) load(); /* eslint-disable-next-line */ }, [leadId]);

  const change = async (status) => {
    if (status === 'future_prospect') {
      toast.info('Pick the follow-up date in the Renewals tab — dates live on the renewal row, not the lead');
      return;
    }
    setSaving(true);
    try {
      await axios.put(`${API_URL}/api/renewals/${row.renewal_lead_id}`, { status }, { withCredentials: true });
      toast.success('Renewal status updated');
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Update failed');
    } finally {
      setSaving(false);
    }
  };

  if (loading || !leadId) return null;

  return (
    <div className="md:col-span-2" data-testid="lead-renewal-status-block">
      <label className="block text-sm font-medium text-slate-700 mb-1">Renewal Status</label>
      {!row ? (
        <div className="rounded-lg border border-dashed border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-500"
          data-testid="lead-renewal-status-inactive">
          Activates when she enters her 32nd week (or delivers). She is then added to the Renewals tab automatically.
        </div>
      ) : (
        <div className="flex flex-wrap items-center gap-3">
          <select value={row.status || 'wip'} disabled={saving}
            onChange={(e) => change(e.target.value)}
            data-testid="lead-renewal-status-select"
            className="input-base max-w-xs text-sm">
            {STATUS_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
          <span className="text-xs text-slate-500" data-testid="lead-renewal-status-meta">
            {row.cycle === 'postnatal_renewal' ? 'Postnatal renewal' : 'Postnatal'} · created {fmt(row.created_at)}
            {row.assigned_rep_name ? ` · ${row.assigned_rep_name}` : ''}
            {row.status === 'future_prospect' && row.follow_up_date ? ` · follow up ${fmt(row.follow_up_date)}` : ''}
          </span>
        </div>
      )}
    </div>
  );
};

export default RenewalStatusField;
